export const configLocal = {
    version: "v 1.0.16",
    environment: process.env.VUE_APP_ENVIRONMENT ?? "Development",
    api: process.env.VUE_APP_ENDPOINT ?? "https://stg-tp-api.sansiri.net/api",
    logapi : process.env.ENDPOINT_LOG ?? "https://stg-api.sansiri.net/sales-api",
    azureAd: {
        clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID ?? 'f461bc51-4756-4379-93e1-4f31f847db83',
        authority: process.env.VUE_APP_AZURE_AD_AUTHORITY ?? 'https://login.microsoftonline.com/875bdd0a-688b-41d2-96b7-454d280043aa',
        scopes: [process.env.VUE_APP_AZURE_AD_SCOPES ?? "api://f461bc51-4756-4379-93e1-4f31f847db83/read", "User.Read"]
    },
    instrumentationKey: process.env.VUE_APP_INSIGHTS_KEY ?? "ac058a43-373b-4006-b740-6cb93681efbb",
    graphMeEndpoint: process.env.VUE_APP_GRAPH_MICROSOFT ?? 'https://graph.microsoft.com',
    pdpa: {
        topic1: "e1aa5622-5acd-4f1b-bfd0-51143b690eec", // เพื่อติดต่อสื่อสาร
        topic2: "23711cc4-2cf0-45e8-a715-c14fdafcbd90", // เพื่อจัดทำแผนการตลาด
        topic3: "10576ea2-919e-41cb-8e4f-725bc177573c", // ส่งให้แก่บุคคลที่สามหรือพันธมิตรทางธุรกิจของบริษัทฯ
    },
    siriApp4Url: "https://sansiriapp4.sansiri.com/",
    siriApp3Url: "https://sansiriapp3.sansiri.com",
}

const configStaging = {
    version: "v 1.0.16",
    environment: process.env.VUE_APP_ENVIRONMENT ?? "Development",
    api: process.env.VUE_APP_ENDPOINT ?? "https://stg-tp-api.sansiri.net/api",
    logapi : process.env.ENDPOINT_LOG ?? "https://stg-api.sansiri.net/sales-api",
    azureAd: {
        clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID ?? 'f461bc51-4756-4379-93e1-4f31f847db83',
        authority: process.env.VUE_APP_AZURE_AD_AUTHORITY ?? 'https://login.microsoftonline.com/875bdd0a-688b-41d2-96b7-454d280043aa',
        scopes: [process.env.VUE_APP_AZURE_AD_SCOPES ?? "api://f461bc51-4756-4379-93e1-4f31f847db83/read", "User.Read"]
    },
    instrumentationKey: process.env.VUE_APP_INSIGHTS_KEY ?? "ac058a43-373b-4006-b740-6cb93681efbb",
    graphMeEndpoint: process.env.VUE_APP_GRAPH_MICROSOFT ?? 'https://graph.microsoft.com',
    pdpa: {
        topic1: "e1aa5622-5acd-4f1b-bfd0-51143b690eec", // เพื่อติดต่อสื่อสาร
        topic2: "23711cc4-2cf0-45e8-a715-c14fdafcbd90", // เพื่อจัดทำแผนการตลาด
        topic3: "10576ea2-919e-41cb-8e4f-725bc177573c", // ส่งให้แก่บุคคลที่สามหรือพันธมิตรทางธุรกิจของบริษัทฯ
    },
    siriApp4Url: "https://webdevteam1.sansiri.com/",
    siriApp3Url: "https://sourcesafe.sansiri.com",
}

export const configProduction = {
    version: "v 1.0.23",
    environment: process.env.VUE_APP_ENVIRONMENT ?? "Production",
    api: process.env.VUE_APP_ENDPOINT ?? "https://tp-api.sansiri.net/api",
    logapi : process.env.ENDPOINT_LOG ?? "https://siriapi.sansiri.com/sales",
    azureAd: {
        clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID ?? '17b6151c-0c51-47fa-a63a-24f82a9e6233',
        authority: process.env.VUE_APP_AZURE_AD_AUTHORITY ?? 'https://login.microsoftonline.com/875bdd0a-688b-41d2-96b7-454d280043aa',
        scopes: [process.env.VUE_APP_AZURE_AD_SCOPES ?? "api://17b6151c-0c51-47fa-a63a-24f82a9e6233/read", "User.Read"]
    },
    instrumentationKey: process.env.VUE_APP_INSIGHTS_KEY ?? "b9f10625-6e99-4327-ad68-901300ab6779",
    graphMeEndpoint: process.env.VUE_APP_GRAPH_MICROSOFT ?? 'https://graph.microsoft.com',
        pdpa: {
        topic1: "04c26662-7339-4bb6-85ee-0fd2080a17d7", // เพื่อติดต่อสื่อสาร
        topic2: "031fe0dd-3084-4908-bce9-4c4039bbde45", // เพื่อจัดทำแผนการตลาด
        topic3: "5f02d015-fd40-4881-95b6-2480290da934", // ส่งให้แก่บุคคลที่สามหรือพันธมิตรทางธุรกิจของบริษัทฯ
    },
    siriApp4Url: "https://sansiriapp4.sansiri.com/",
    siriApp3Url: "https://sansiriapp3.sansiri.com",
}

const ENVIRONMENT: string = process.env.VUE_APP_ENVIRONMENT
let isConifg: any = configLocal
if (ENVIRONMENT.toLocaleLowerCase() === "staging") isConifg = configStaging
if (ENVIRONMENT.toLocaleLowerCase() === "production") isConifg = configProduction

// let isConifg: any = configLocal

export const config = isConifg

